// Script melhorado para calculadora de frete que funciona mesmo com carrinho vazio
// Adiciona temporariamente o produto ao carrinho para calcular frete, depois remove

function initializeShippingCalculator(calculator) {
  if (!calculator || !calculator.isConnected) {
    return;
  }

  if (calculator._shippingCalculatorInitialized) {
    return;
  }

  const countrySelect = calculator.querySelector(".js-country-select");
  const provinceSelect = calculator.querySelector(".js-province-select");
  const zipInput = calculator.querySelector(".js-zip-input");
  const loadingDiv = calculator.querySelector(".js-cep-loading");
  const calcButton = calculator.querySelector('button[type="button"]');

  if (!(countrySelect && provinceSelect && zipInput && calcButton)) {
    return;
  }

  countrySelect.value = "Brazil";

  const changeEvent = new Event("change", { bubbles: true });
  countrySelect.dispatchEvent(changeEvent);

  const estadosBrasil = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  };

  function formatCEP(value) {
    value = value.replace(/\D/g, "");
    if (value.length > 5) {
      value = value.slice(0, 5) + "-" + value.slice(5, 8);
    }
    return value;
  }

  async function buscarCEP(cep) {
    try {
      const cepLimpo = cep.replace(/\D/g, "");
      if (cepLimpo.length !== 8) return null;

      if (loadingDiv) {
        loadingDiv.style.display = "block";
      }

      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();

      if (loadingDiv) {
        loadingDiv.style.display = "none";
      }

      if (data.erro) return null;

      return {
        uf: data.uf,
        cidade: data.localidade,
        bairro: data.bairro,
        logradouro: data.logradouro,
      };
    } catch (error) {
      if (loadingDiv) {
        loadingDiv.style.display = "none";
      }
      return null;
    }
  }

  function selecionarEstado(uf) {
    const nomeEstado = estadosBrasil[uf];
    if (nomeEstado) {
      const options = provinceSelect.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i].text === nomeEstado || options[i].value === nomeEstado) {
          provinceSelect.selectedIndex = i;
          break;
        }
      }
    }
  }

  function getCurrentProduct() {
    try {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          return variantInput.value;
        }
      }

      const productElement = document.querySelector("[data-product-id]");
      if (productElement) {
        const variantSelect = document.querySelector('[name="id"]');
        if (variantSelect && variantSelect.value) {
          return variantSelect.value;
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  async function getDeliveryPromises(variantId, zip, country, province) {
    try {
      const query = `
        query Proposal($input: ProposalInput!) {
          proposal(input: $input) {
            availableDeliveryStrategies {
              title
              handle
              deliveryPromisePresentmentTitle {
                short
                long
              }
              deliveryStrategyBreakdown {
                amount {
                  value {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `;

      const variables = {
        input: {
          lines: [
            {
              variantId: `gid://shopify/ProductVariant/${variantId}`,
              quantity: 1,
            },
          ],
          shippingAddress: {
            zip,
            countryCode: country === "Brazil" ? "BR" : country,
            provinceCode: province,
          },
        },
      };

      const response = await fetch(
        "/checkouts/unstable/graphql?operationName=Proposal",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            query,
            variables,
            operationName: "Proposal",
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data?.data?.proposal?.availableDeliveryStrategies || [];
      }
    } catch (error) {}

    return [];
  }

  async function calcularFreteComProduto(zip, country, province) {
    const errors = calculator.querySelector(".js-errors");
    const rates = calculator.querySelector(".js-rates");
    const button = calcButton;

    try {
      if (errors) errors.hidden = true;
      if (rates) rates.hidden = true;

      button.disabled = true;
      button.textContent = "Calculando frete...";
      button.classList.add("is-loading");

      const cartResponse = await fetch("/cart.json");
      const cartData = await cartResponse.json();

      let needsRestore = false;
      let originalCart = null;
      let currentVariantId = getCurrentProduct();

      if (!cartData.items || cartData.items.length === 0) {
        if (!currentVariantId) {
          showErrorsResult(calculator, {
            error: "Adicione um produto ao carrinho para calcular o frete.",
          });
          button.classList.remove("is-loading");
          button.disabled = false;
          button.textContent = "Calcular frete";
          return;
        }

        originalCart = cartData;
        needsRestore = true;

        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: currentVariantId,
            quantity: 1,
          }),
        });

        if (!addResponse.ok) {
          throw new Error("Erro ao adicionar produto temporário");
        }

        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      let deliveryPromises = [];
      if (currentVariantId) {
        button.textContent = "Buscando prazos de entrega...";
        deliveryPromises = await getDeliveryPromises(
          currentVariantId,
          zip,
          country,
          province
        );
      }

      button.textContent = "Calculando valores...";
      const params = `shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

      const shippingResponse = await fetch(
        `/cart/shipping_rates.json?${params}`
      );
      const shippingData = await shippingResponse.json();

      if (needsRestore) {
        try {
          await fetch("/cart/clear.js", { method: "POST" });
        } catch (clearError) {}
      }

      if (shippingResponse.ok) {
        showRatesResultWithPromises(
          calculator,
          shippingData,
          deliveryPromises
        );
      } else {
        showErrorsResult(
          calculator,
          shippingData || { error: "Erro ao calcular frete" }
        );
      }
    } catch (error) {
      showErrorsResult(calculator, {
        error: "Erro ao calcular frete. Tente novamente.",
      });
    } finally {
      calcButton.classList.remove("is-loading");
      calcButton.disabled = false;
      calcButton.textContent = "Calcular frete";
    }
  }

  const handleZipInput = function (e) {
    const cursorPosition = e.target.selectionStart;
    const formattedValue = formatCEP(e.target.value);
    e.target.value = formattedValue;

    if (formattedValue.length === 6 && cursorPosition === 5) {
      e.target.setSelectionRange(6, 6);
    }
  };

  if (zipInput._shippingCalculatorInputHandler) {
    zipInput.removeEventListener(
      "input",
      zipInput._shippingCalculatorInputHandler
    );
  }
  zipInput.addEventListener("input", handleZipInput);
  zipInput._shippingCalculatorInputHandler = handleZipInput;

  const handleZipBlur = async function (e) {
    const cep = e.target.value;
    if (cep.length === 9) {
      await processarCEPCompleto(cep);
    }
  };

  if (zipInput._shippingCalculatorBlurHandler) {
    zipInput.removeEventListener(
      "blur",
      zipInput._shippingCalculatorBlurHandler
    );
  }
  zipInput.addEventListener("blur", handleZipBlur);
  zipInput._shippingCalculatorBlurHandler = handleZipBlur;

  async function processarCEPCompleto(cep) {
    try {
      calcButton.disabled = true;
      calcButton.textContent = "Buscando localização...";
      calcButton.classList.add("is-loading");

      const dadosCEP = await buscarCEP(cep);
      if (!dadosCEP) {
        throw new Error("CEP não encontrado");
      }

      calcButton.textContent = "Selecionando estado...";
      await new Promise((resolve) => {
        setTimeout(() => {
          selecionarEstado(dadosCEP.uf);
          resolve();
        }, 300);
      });

      calcButton.textContent = "Calculando frete...";
      await calcularFreteComProduto(cep, "Brazil", provinceSelect.value);
    } catch (error) {
      calcButton.classList.remove("is-loading");
      calcButton.disabled = false;
      calcButton.textContent = "Calcular frete";

      zipInput.style.borderColor = "#ff4444";
      setTimeout(() => {
        zipInput.style.borderColor = "";
      }, 3000);
    }
  }

  const handleCalcClick = async function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const cepPattern = /^[0-9]{5}-[0-9]{3}$/;
    if (!cepPattern.test(zipInput.value)) {
      zipInput.style.borderColor = "#ff4444";
      zipInput.focus();
      setTimeout(() => {
        zipInput.style.borderColor = "";
      }, 3000);
      return;
    }

    if (!provinceSelect.value || provinceSelect.selectedIndex === 0) {
      await processarCEPCompleto(zipInput.value);
    } else {
      await calcularFreteComProduto(
        zipInput.value,
        "Brazil",
        provinceSelect.value
      );
    }
  };

  if (calcButton._shippingCalculatorClickHandler) {
    calcButton.removeEventListener(
      "click",
      calcButton._shippingCalculatorClickHandler
    );
  }
  calcButton.addEventListener("click", handleCalcClick);
  calcButton._shippingCalculatorClickHandler = handleCalcClick;

  if (zipInput.value) {
    zipInput.value = formatCEP(zipInput.value);
  }

  calculator._shippingCalculatorInitialized = true;
}

function initShippingCalculators(root = document) {
  if (!root) return;

  const scope =
    root instanceof Element || root instanceof DocumentFragment
      ? root
      : document;

  const calculators = scope.querySelectorAll("shipping-calculator");

  calculators.forEach((calculator) => {
    initializeShippingCalculator(calculator);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initShippingCalculators(document);
});

document.addEventListener("shopify:section:load", (event) => {
  initShippingCalculators(event && event.target ? event.target : document);
});

document.addEventListener("on:cart:after-merge", (event) => {
  const container =
    event && event.target && event.target.closest
      ? event.target.closest("cart-drawer, cart-form") || event.target
      : document;
  initShippingCalculators(container);
});

if (document.readyState === "interactive" || document.readyState === "complete") {
  initShippingCalculators(document);
}

function showRatesResultWithPromises(calculator, shippingData, deliveryPromises) {
  const rates = calculator.querySelector(".js-rates");
  const headingEl = rates.querySelector(".js-rates-heading");
  const textEl = rates.querySelector(".js-rates-text");
  textEl.innerHTML = "";

  if (shippingData.shipping_rates && shippingData.shipping_rates.length) {
    let ratesHTML = "";

    shippingData.shipping_rates.forEach((rate) => {
      let formattedRate = rate.price;
      if (window.theme?.settings?.moneyWithCurrencyFormat) {
        formattedRate = window.theme.settings.moneyWithCurrencyFormat.replace(
          /\{\{\s*(\w+)\s*\}\}/g,
          rate.price
        );
      } else {
        const priceInReais =
          typeof rate.price === "string"
            ? rate.price
            : `R$ ${(rate.price / 100).toFixed(2).replace(".", ",")}`;
        formattedRate = priceInReais;
      }

      let deliveryText = "";

      if (
        rate.delivery_days &&
        Array.isArray(rate.delivery_days) &&
        rate.delivery_days.length > 0
      ) {
        const days = rate.delivery_days[0];

        if (days === 0) {
          deliveryText = "Retirada imediata";
        } else if (days === 1) {
          deliveryText = "1 dia útil";
        } else {
          deliveryText = `${days} dias úteis`;
        }
      } else if (rate.delivery_date) {
        const deliveryDate = new Date(rate.delivery_date);
        const today = new Date();
        const diffTime = deliveryDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays <= 0) {
          deliveryText = "Retirada imediata";
        } else if (diffDays === 1) {
          deliveryText = "1 dia útil";
        } else {
          deliveryText = `${diffDays} dias úteis`;
        }
      } else if (deliveryPromises && deliveryPromises.length > 0) {
        const matchingPromise = deliveryPromises.find((promise) => {
          const promiseName = promise.title.toLowerCase().trim();
          const rateName = rate.name.toLowerCase().trim();

          const match =
            promiseName.includes(rateName) ||
            rateName.includes(promiseName) ||
            (promiseName.includes("loggi") && rateName.includes("loggi")) ||
            (promiseName.includes("pac") && rateName.includes("pac")) ||
            (promiseName.includes("sedex") && rateName.includes("sedex"));

          return match;
        });

        if (
          matchingPromise &&
          matchingPromise.deliveryPromisePresentmentTitle
        ) {
          deliveryText =
            matchingPromise.deliveryPromisePresentmentTitle.short ||
            matchingPromise.deliveryPromisePresentmentTitle.long;
        }
      }

      if (!deliveryText) {
        deliveryText = getDeliveryDays(rate.name);

        if (deliveryText === "0") {
          deliveryText = "Retirada imediata";
        } else if (deliveryText === "1") {
          deliveryText = "1 dia útil";
        } else if (deliveryText.includes("-")) {
          deliveryText = deliveryText.includes("dias")
            ? deliveryText
            : `${deliveryText} dias úteis`;
        } else {
          deliveryText = deliveryText.includes("dia")
            ? deliveryText
            : `${deliveryText} dias úteis`;
        }
      }

      ratesHTML += `<li><strong>${rate.name}</strong>: ${deliveryText} - ${formattedRate}</li>`;
    });

    headingEl.hidden = false;
    headingEl.textContent =
      shippingData.shipping_rates.length === 1
        ? "Opção de entrega:"
        : "Opções de entrega:";
    textEl.innerHTML = `<ul class="styled-list">${ratesHTML}</ul>`;
  } else {
    headingEl.hidden = true;
    textEl.innerHTML = "Nenhuma opção de entrega disponível para este CEP.";
  }

  rates.hidden = false;
}

function getDeliveryDays(rateName) {
  const rateLower = rateName.toLowerCase();

  const deliveryMap = {
    loggi: "1-2",
    pac: "8-12",
    sedex: "2-4",
    express: "1-2",
    expresso: "1-2",
    rapido: "1-2",
    economico: "8-15",
    padrão: "5-10",
    padrao: "5-10",
    normal: "5-10",
    correios: "5-10",
    motoboy: "1",
    retirada: "0",
  };

  for (const [key, days] of Object.entries(deliveryMap)) {
    if (rateLower.includes(key)) {
      return days;
    }
  }

  return "5-10";
}

function showErrorsResult(calculator, data) {
  const errors = calculator.querySelector(".js-errors");
  let errorsHTML = "";

  if (typeof data === "object" && data !== null) {
    Object.keys(data).forEach((key) => {
      errorsHTML += `<li>${data[key]}</li>`;
    });
  } else {
    errorsHTML = `<li>Erro ao calcular frete. Verifique o CEP e tente novamente.</li>`;
  }

  errors.querySelector(
    ".js-errors-text"
  ).innerHTML = `<ul class="styled-list">${errorsHTML}</ul>`;
  errors.hidden = false;
}
